import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {from, Observable} from 'rxjs';
import {LoadDataBegin} from '@app/components/projects/surveys/annotation/store/annotation.actions';
import {AppState} from '@app/store/app.states';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {IDictionnaries} from '@app/components/projects/surveys/annotation/store/annotations.entitiy';
import {removeUndefined} from '@app/components/_common/firebase.utilities';

// const configuration = new Configuration({
//   apiKey: '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'
// });
// const openai = new OpenAIApi(configuration);


@Injectable({
  providedIn: 'root'
})
export class AnnotationService {
  private BASE_URL = environment.apiUrl;
  private BASSS = 'https://inbe-dashboard-data.s3.ca-central-1.amazonaws.com';
  private baseCollection = environment.firestoreAnnotationsCollection;

  currentURL: string;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private afs: AngularFirestore
  ) {
  }

  //
  // Retourne une URL s3 maintenant
  //
  get(surveyId: any): Observable<any> {
    const url = `${this.BASE_URL}/annotations/${surveyId}`;
    this.currentURL = `${this.BASSS}/dev/annotations/${surveyId}.json`;
    return this.http.get<any>(url);
  }

  //
  //
  // Save with uplaod S3
  //
  //
  // Step 1 : Get a signed url for Post
  //
  getAnnotationSaveUrlPost(surveyId: number = -1) {
    const url = `${this.BASE_URL}/annotations/actions`;
    return this.http.post<any>(url, {
      action: 'getAnnotationSaveUrlPost',
      params: {surveyId}
    });
  }

  //
  // Step 2 : Put to the url
  //
  putAnnotationsDatasToSignerUrl(signedUrl: string, datas: any) {
    return this.http.put<any>(signedUrl, datas);
  }


  setDictionariesToFirebase(surveyId: string, dictionaries: IDictionnaries) {
    Object.entries(dictionaries || {}).forEach(dict => {
      if (Object.keys(dict[1]).length) {
        this.afs.doc(`${this.baseCollection}/${surveyId}/list/${dict[0]}`).set(removeUndefined(dict[1])).then();
      }
    });
  }
}
